import { Service } from '@roc/feature-app-core';

const url = {
  GET_DISPUTE_FORM: '/api/v1/roc-valuation/taskValuation/getDisputeForm',
  SAVE_DISPUTE_FORM: '/api/v1/roc-valuation/taskValuation/saveDisputeForm',
  SAVE_COMPLETION_NOTE: '/api/v1/roc-valuation/taskValuation/saveCompletionNote',
};

export class ValuationDisputeService extends Service {
  getDisputeForm(loanId: number, propertyId: number, taskName: string) {
    return this.get(url.GET_DISPUTE_FORM, { loanId, propertyId, taskName });
  }

  saveDisputeForm(taskId: number, loanId: number, propertyId: number, taskName: string, disputeForm: string) {
    return this.post(
      `${url.SAVE_DISPUTE_FORM}?loanId=${loanId}&propertyId=${propertyId}&taskId=${taskId}&taskName=${encodeURIComponent(taskName)}`,
      disputeForm,
      { 'Content-Type': 'application/json' }
    );
  }

  saveCompletionNote(taskId: number, loanId: number, propertyId: number, taskName: string, completionNote: string) {
    return this.post(
      `${url.SAVE_COMPLETION_NOTE}?loanId=${loanId}&propertyId=${propertyId}&taskId=${taskId}&taskName=${encodeURIComponent(taskName)}&completionNote=${encodeURIComponent(completionNote)}`,
      null
    );
  }
}
